import { useQuery } from "@tanstack/react-query";
import { fetchPurchaseById } from "@/services/api";
import { toast } from "sonner";

export const usePurchaseDetail = (purchaseAccessId: string | undefined) => {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["purchase", purchaseAccessId],
    queryFn: () => fetchPurchaseById(purchaseAccessId!),
    enabled: !!purchaseAccessId,
    retry: 1,
    refetchOnWindowFocus: false,
    meta: {
      onError: (err: Error) => {
        toast.error("Failed to load purchase details", {
          description: "Please check the purchase ID and try again later.",
        });
        console.error("Error fetching purchase:", err);
      },
    },
  });

  return {
    data,
    isLoading,
    isError,
    error,
  };
};
